<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>
</div>
<div mat-dialog-actions>
  <button *ngFor="let answer of answers" mat-button (click)="selectedAnswer(answer)">{{answer}}</button>
</div>
